//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            02nd October 2018
//  * @type            Login Component File
//  * @description -   This file renders the html and functionality for logging into the app.
<template>
    <v-wait for="logging in">
        <template slot="waiting">
            <div id="loadingDiv" class="loadingDiv_analytics">
                <div class="loadersec">
                    <div class="loader"></div>
                </div>
            </div>
        </template>
        <div class="wrapper login" v-if="!ssoStatus" :style="{ display: ssoStatus ? 'none' : 'block' }">
            <div class="login-modal" >
                <div class="left-side">         
                    <div class="login_box">
                        <div class="w-100">
                            <div class="text-center">
                                <a href class="logo-fn main-bg">
                                    <img :src="logoImage" alt="Logo" @error="imageUrlAlt" />
                                </a>
                                <h3 class="modal-head">Sign In</h3>
                            </div>
                            <div v-if="domain ? (domain.length <= 0 || domain === 'www') : 1">
                                <form @submit.prevent="verifyAccount">
                                    <div
                                        v-if="domain ? (domain.length <= 0 || domain === 'www') : 1"
                                        class="input_box input-group form-group"
                                        v-bind:class="[isActive3 ? 'focus_input' : '']">
                                        <input
                                            v-model="account"
                                            @change="addClass3"
                                            id="inputAccount"
                                            type="text"
                                            class="form-control input_focus"
                                            placeholder="Account Name"
                                            required
                                            autofocus />
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">
                                              <svg id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m482.284 482h-39.573v-467c0-8.284-6.716-15-15-15h-343.423c-8.284 0-15 6.716-15 15v467h-39.572c-8.284 0-15 6.716-15 15s6.716 15 15 15h452.569c8.284 0 15-6.716 15-15s-6.716-15-15.001-15zm-277.415 0v-102.261h102.261v102.261zm132.261 0v-117.261c0-8.284-6.716-15-15-15h-132.261c-8.284 0-15 6.716-15 15v117.261h-75.581v-452h313.423v452z"/><path d="m223.748 66.309h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z"/><path d="m361.76 66.309h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z"/><path d="m223.748 205.954h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z"/><path d="m361.76 205.954h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z"/></g></svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group login_btn_div">
                                        <button type="submit" class="login_btn">LOG IN</button>
                                    </div>
                                    <div
                                        :class="error === 'Invalid username or password! Your account will be locked after 5 failed login attempts.' ? 'alert alert-warning login-warn' : 'alert alert-danger'"
                                        v-if="error" >
                                        <i
                                            v-if="error === 'Invalid username or password! Your account will be locked after 5 failed login attempts.'"
                                            class="fa fa-exclamation-triangle"
                                            aria-hidden="true"
                                        ></i>
                                        {{ error }}
                                        <span v-if="errorSupport">
                                            <a
                                            href="javascript:void(0)"
                                            id="btnViewSupportModal"
                                            @click="$refs.supportModal.show()"
                                            >Support Team</a>
                                        </span>
                                    </div>
                                    <div v-if="verificationLink" class="alert alert-danger">This Account is inactive. <a href="javascript:void(0)" @click="resendVerificationEmail" style="text-decoration: underline;">Resend Activation email.</a></div>
                                </form>
                                <div class="row">
                                    <div class="col-12 text-right">
                                        <router-link :to="{ name : 'ForgotPassword', path : '/forgot-pswd', params: { siteDefaultTitle: this.siteTitle } }" class="f-password">Forgot Password?</router-link>
                                    </div>
                                </div>
                            </div> 
                            <div >
                              <!-- v-else remove by din for local -->
                                <form @submit.prevent="login">
                                    <!-- Login Step -->
                                    <div v-if="!showOtpStep">
                                        <div class="input_box input-group form-group" v-bind:class="[isActive1 ? 'focus_input' : '']">
                                            <input
                                            v-model="email"
                                            @change="addClass1"
                                            id="inputEmail"
                                            type="text"
                                            class="form-control input_focus"
                                            placeholder="Email or Username"
                                            required
                                            autofocus
                                            />
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1">
                                                    <i class="fa fa-user-o" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="input_box input-group form-group" v-bind:class="[isActive2 ? 'focus_input' : '']">
                                            <input
                                            v-model="password"
                                            @change="addClass2"
                                            id="inputPassword"
                                            type="password"
                                            class="form-control input_focus"
                                            placeholder="Password"
                                            required
                                            />
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1">
                                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                      viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                                      <g>
                                                        <g>
                                                          <path d="M330.704,170.667H95.963C78.405,170.667,64,184.951,64,202.572v192.19c0,17.593,14.31,31.905,31.963,31.905h234.742
                                                            c17.557,0,31.963-14.284,31.963-31.905v-192.19C362.667,184.979,348.357,170.667,330.704,170.667z M320,384H106.667V213.333H320
                                                            V384z"/>
                                                        </g>
                                                      </g>
                                                      <g>
                                                        <g>
                                                          <path d="M217.082,0h-7.498c-56.815,0-102.918,46.172-102.918,102.978v81.645h42.667v-81.645c0-33.256,27.014-60.311,60.251-60.311
                                                            h7.498c33.22,0,60.251,27.032,60.251,60.311v81.645H320v-81.645C320,46.134,273.866,0,217.082,0z"/>
                                                        </g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                      <g>
                                                      </g>
                                                    </svg>
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            :class="error === 'Invalid username or password! Your account will be locked after 5 failed login attempts.' ? 'alert alert-warning login-warn' : 'alert alert-danger'"
                                            v-if="error"
                                            >
                                            <i
                                                v-if="error === 'Invalid username or password! Your account will be locked after 5 failed login attempts.'"
                                                class="fa fa-exclamation-triangle"
                                                aria-hidden="true"
                                            ></i>
                                            {{ error }}
                                            <span v-if="errorSupport">
                                                <a
                                                href="javascript:void(0)"
                                                id="btnViewSupportModal"
                                                @click="$refs.supportModal.show()"
                                                >Support Team</a>
                                            </span>
                                        </div>
                                        <div class="form-group">
                                            <div ref="recaptchaContainer" id="recaptchaLogin"></div>
                                        </div>
                                        <!-- OTP Sending Loader -->
                                        <div class="otp-sending-loader" v-if="sendingOtp">
                                            <div class="loader-overlay">
                                                <div class="loader-content">
                                                    <div class="spinner">
                                                        <div class="spinner-circle"></div>
                                                    </div>
                                                    <p class="loader-text">Sending verification code...</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group login_btn_div">
                                            <button type="submit" class="login_btn">LOG IN</button>
                                        </div>
                                    </div>

                                    <!-- OTP Verification Step -->
                                    <div v-else class="otp-inline-container">
                                        <!-- OTP Sending Loader -->
                                        <div class="otp-sending-loader" v-if="sendingOtp">
                                            <div class="loader-overlay">
                                                <div class="loader-content">
                                                    <div class="spinner">
                                                        <div class="spinner-circle"></div>
                                                    </div>
                                                    <p class="loader-text">Sending verification code...</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="otp-inline-header">
                                            <!-- <h3 class="otp-inline-title">
                                                <i class="fa fa-shield"></i> Verify Your Identity
                                            </h3> -->
                                            <p class="otp-inline-subtitle">Enter the 6-digit code sent to your email</p>
                                        </div>

                                        <div class="otp-inline-body">
                                            <div class="otp-input-wrapper">
                                                <input
                                                    type="text"
                                                    v-model="otpCode"
                                                    class="otp-input-field"
                                                    id="otpInputInline"
                                                    maxlength="6"
                                                    placeholder="000000"
                                                    @keypress="onlyNumbers"
                                                    @keyup.enter="verifyOtp"
                                                    autofocus
                                                />
                                                <div class="otp-input-underline"></div>
                                            </div>

                                            <!-- Error Message -->
                                            <transition name="fade">
                                                <div class="otp-error-message" v-if="otpError">
                                                    <i class="fa fa-exclamation-circle"></i>
                                                    <span>{{ otpError }}</span>
                                                </div>
                                            </transition>

                                            <!-- Timer and Resend -->
                                            <div class="otp-timer-section">
                                                <div v-if="!canResendOtp" class="otp-timer">
                                                    <i class="fa fa-clock-o"></i>
                                                    <span>Resend code in <strong>{{ otpTimer }}s</strong></span>
                                                </div>
                                                <a v-else href="javascript:void(0)" @click="resendOtp" class="otp-resend-link">
                                                    <i class="fa fa-redo"></i>
                                                    <span>Resend Code</span>
                                                </a>
                                            </div>
                                        </div>

                                        <div class="form-group remember-me-checkbox" style="margin-top: 10px;">
                                            <label class="custom-checkbox">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="rememberMe"
                                                    class="checkbox-input"
                                                />
                                                <span class="checkbox-label">Skip verification for 30 days</span>
                                            </label>
                                        </div>

                                        <div class="otp-inline-footer">
                                            <button type="button" @click="goBackToLogin" class="otp-btn otp-btn-back" :disabled="otpVerifying">
                                                <i class="fa fa-arrow-left"></i>
                                                Back
                                            </button>
                                            <button type="button" @click="verifyOtp" class="otp-btn otp-btn-verify" :disabled="otpCode.length !== 6 || otpVerifying">
                                                <span v-if="otpVerifying">
                                                    <i class="fa fa-spinner fa-spin"></i>
                                                    <span class="ml-2">Verifying...</span>
                                                </span>
                                                <span v-else>
                                                    <i class="fa fa-check"></i>
                                                    <span class="ml-2">Verify Code</span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                                <div class="row" v-if="!showOtpStep">
                                    <div class="col-12 text-right">
                                        <router-link :to="{ name : 'ForgotPassword', path : '/forgot-pswd', params: { siteDefaultTitle: this.siteTitle } }" class="f-password">Forgot Password?</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="join-us">
                    <span class="">Don't have an account yet?<a :href="signupUrl" target="_blank">Join Tapapp</a></span>
                </div>
            </div>
            <div class="rulesAndRegulation">
              <a
                  href="https://tapapp.co.uk/terms-conditions"
                  target="_blank"
                  class="linkTermsandConditions"
                  id="linkTermsandConditions"
                  rel="noopener noreferrer"
              >Terms and Conditions</a>
              <span class="tandcpipe">|</span>
              <a
                  href="https://tapapp.co.uk/privacy-policy"
                  target="_blank"
                  class="linkPrivacyPolicy"
                  id="linkPrivacyPolicy"
                  rel="noopener noreferrer"
              >Privacy Policy</a>
              <span class="tandcpipe">|</span>
              <a
                  href="https://outlook.office.com/book/TapappDemowithGintas@tapapp.cloud/?ismsaljsauthenabled"
                  target="_blank"
                  class=""
                  id=""
                  rel="noopener noreferrer"
              >Demo</a>
              <span class="tandcpipe">|</span>

              <!-- id="btnViewSupportModal"
                  @click="$refs.supportModal.show()" -->
              <a href="https://tapapp.co.uk" target="_blank" rel="noopener noreferrer">Support</a>
          </div>
          <div class="version">Version: {{currentVersion}}</div>
        </div>
        <div v-if="ssoStatus">
            <div id="loadingDiv" class="loadingDiv_analytics">
                <div class="loadersec">
                    <div class="loader"></div>
                </div>
            </div>
        </div>
        <b-modal ref="supportModal" id="supportModal" hide-footer>
            <template slot="modal-header">
            <h4 class="modal-title">
                <b>Contact us</b>
            </h4>
            <div
                class="row"
                v-if="dialogsData.in_support_email_status || dialogsData.st_site_support_telephone"
            >
                <div class="col-md-5">
                <h4 class="contact-us-detail" v-if="dialogsData.in_telephone_status">
                    <i class="fa fa-phone marginR10"></i>
                    {{dialogsData.st_site_support_telephone}}
                </h4>
                </div>
                <div
                class="col-md-7"
                
                >
                <h4 class="contact-us-detail" v-if="dialogsData.in_support_email_status">
                    <i class="fa fa-at marginR10"></i>
                    {{dialogsData.st_site_support_email}}
                </h4>
                </div>
            </div>

            <div class="custom-modal-header-close" slot="modal-header-close">
                <button
                type="button"
                class="close"
                @click="$refs['supportModal'].hide()"
                aria-label="Close"
                >
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            </template>
            <div class="row session-exp-container">
            <form name="frmAddEditSupport" id="frmAddEditSupport" v-on:submit.prevent>
                <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <p>
                    Send us a support request. For technical support, issues or feedback,
                    please fill in this form and we'd be happy to assist.
                    </p>
                </div>
                </div>
                <div class="row marginB10">
                <div class="col-xs-12 col-sm-12 col-md-12">
                    <div class="form-group form-group-new">
                
                    <div class="col-sm-12">
                        <label class="control-label" for="email">Email Address</label> 
                        <input
                        type="text"
                        name="txtUserSupportEmail"
                        v-model="txtUserSupportEmail"
                        class="form-control support-mail"
                        id="email"
                        v-validate="'required|email'"
                        data-vv-as="above"
                        />
                        <span
                        class="error"
                        v-if="errors.has('txtUserSupportEmail')"
                        >{{ errors.first('txtUserSupportEmail') }}</span>
                    </div>
                    </div>
                </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 marginB10">
                <div class="form-group">
                    <textarea
                    v-model="txtSupportMessage"
                    name="txtSupportMessage"
                    rows="9"
                    id="txtSupportMessage"
                    class="form-control"
                    v-validate="'required'"
                    data-vv-as="above"
                    ></textarea>
                    <span
                    class="error"
                    v-if="errors.has('txtSupportMessage')"
                    >{{ errors.first('txtSupportMessage') }}</span>
                </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 marginB10">
                <div class="form-group">
                    <vue-dropzone
                    ref="txtSupportFile"
                    :options="dropzoneOptions"
                    :include-styling="false"
                    :useCustomSlot="true"
                    id="supportDropzone"
                    >
                    <!-- <div class="dropzone-custom-content">
                        <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                        <div class="subtitle">...or click to select a file from your computer</div>
                    </div>-->
                    <div
                        class="dropzone drop-box needsclick dz-clickable marginLR0 width100"
                        id="supportFileAttachment"
                    >
                        <div class="dz-message needsclick">
                        <span>
                            Drop files to upload, or
                            <button
                            class="btn-ok-support support-fileinput-button"
                            type="button"
                            >browse</button>
                        </span>
                        </div>
                        <ul class="files" id="supportPreviews"></ul>
                    </div>
                    </vue-dropzone>
                </div>
                </div>
            </form>
            </div>

            <div class="survey_settings row">
            <div class="col-md-12">
                <div class="cl-submit-btn pull-right">
                <button
                    @click="$refs['supportModal'].hide()"
                    class="btn btn-cancel"
                    aria-label="Close"
                >Cancel</button>
                <button
                    @click.prevent="sendSupport"
                    class="btn btn-ok"
                    id="btnSendSupportRequest"
                >Send</button>
                </div>
            </div>
            </div>
        </b-modal>
        <!-- OTP Verification Modal -->
        <b-modal ref="otpModal" id="otpModal" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close centered class="otp-modal-wrapper">
            <div class="otp-modal-content">
                <div class="otp-header">
                    <h2 class="otp-title">Verify Your Identity</h2>
                    <p class="otp-subtitle">Enter the 6-digit code sent to your email</p>
                </div>

                <div class="otp-body">
                    <div class="otp-input-wrapper">
                        <input
                            type="text"
                            v-model="otpCode"
                            class="otp-input-field"
                            id="otpInput"
                            maxlength="6"
                            placeholder="000000"
                            @keypress="onlyNumbers"
                            @keyup.enter="verifyOtp"
                            autofocus
                        />
                        <div class="otp-input-underline"></div>
                    </div>

                    <!-- Error Message -->
                    <transition name="fade">
                        <div class="otp-error-message" v-if="otpError">
                            <i class="fa fa-exclamation-circle"></i>
                            <span>{{ otpError }}</span>
                        </div>
                    </transition>

                    <!-- Timer and Resend -->
                    <div class="otp-timer-section">
                        <div v-if="!canResendOtp" class="otp-timer">
                            <i class="fa fa-clock-o"></i>
                            <span>Resend code in <strong>{{ otpTimer }}s</strong></span>
                        </div>
                        <a v-else href="javascript:void(0)" @click="resendOtp" class="otp-resend-link">
                            <i class="fa fa-redo"></i>
                            <span>Resend Code</span>
                        </a>
                    </div>
                </div>

                <div class="otp-footer">
                    <button @click="cancelOtp" class="otp-btn otp-btn-cancel" :disabled="otpVerifying">
                        Cancel
                    </button>
                    <button @click="verifyOtp" class="otp-btn otp-btn-verify" :disabled="otpCode.length !== 6 || otpVerifying">
                        <span v-if="otpVerifying">
                            <i class="fa fa-spinner fa-spin"></i>
                            <span class="ml-2">Verifying...</span>
                        </span>
                        <span v-else>
                            <i class="fa fa-check"></i>
                            <span class="ml-2">Verify Code</span>
                        </span>
                    </button>
                </div>

                <div class="otp-footer-info">
                    <i class="fa fa-info-circle"></i>
                    <small>Code expires in 15 minutes. Check your spam folder if you don't see the email.</small>
                </div>
            </div>
        </b-modal>
    </v-wait>
</template>

<script>
var supportFormData = new FormData();
// import styles from '../assets/css/bootstrap.min.css'
// import style from '../assets/css/sidebar.css'
// import('../assets/js/popper.min.js')
// import('../assets/js/bootstrap.min.js')
// import('../assets/js/holder.min.js')
// import('../assets/js/jquery-3.3.1.slim.min.js')
// import('../assets/js/jscolor.js')
// import('../assets/js/jquery-2.0.3.min.js')
// import('../assets/js/jquery.uploadPreview.min.js')
var Editor = require("@tinymce/tinymce-vue").default;

var { frontHostName, redirectUrl, signupUrl, defaultWhiteLabel, currentVersion, encrypted_key, recaptchaSiteKey } = require("../../config/config.js");
import CryptoJS from "crypto-js";

export default {
  name: "LoginNew",
  components: {
    Editor
  },
  metaInfo() {
    return {
      title: "Login" + this.siteTitle,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "Login to your Tapapp account - the most powerful, secure, and cost-effective way to automate data collection. Perfect for audits, inspections or checklists."
        }
      ]
    };
  },
  data() {
    return {
      email: "",
      password: "",
      account: "",
      error: false,
      isActive1: 0,
      isActive2: 0,
      isActive3: 0,
      logoImage: require("../assets/images/tapapp_logo.png"),
      dialogsData: [],
      txtUserSupportEmail: "",
      txtSupportMessage: "",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        acceptedFiles: ".jpeg, .jpg, .png, .gif",
        maxFilesize: 2,
        maxFiles: 5,
        addRemoveLinks: false,
        parallelUploads: 100,
        previewTemplate: this.previewTemplate(),
        previewsContainer: "#supportPreviews", // Define the container to display the previews
        clickable: ".support-fileinput-button" // Define the element that should be used as click trigger to select files.
      },
      currentVersion: currentVersion,
      errorSupport: false,
      signupUrl: '',
      verificationLink : false,
      siteTitle: '',
      siteDefaultTitle: '',
      subscriberid: '',
      isSso:false,
      ssoStatus:false,
      adminLoginToken: '',
      recaptchaToken: '',
      recaptchaLoginToken: '',
      recaptchaExpired: false,
      recaptchaLoginExpired: false,
      recaptchaWidgetId: null,
      // OTP verification properties
      showOtpModal: false,
      showOtpStep: false,
      otpCode: '',
      otpError: '',
      otpTimer: 60,
      otpTimerInterval: null,
      canResendOtp: false,
      otpVerifying: false,
      tempLoginData: null,
      // Remember me property
      rememberMe: false,
      // OTP sending loader
      sendingOtp: false,
    };
  },
  props: ["domain", "whitelabel", "subscriptionId", "adminToken"],
  async mounted() {
    this.signupUrl = signupUrl;
    
    // Make reCAPTCHA callback methods globally available
    window.onVerifyLoginCaptcha = this.onVerifyLoginCaptcha;
    window.onExpireLoginCaptcha = this.onExpireLoginCaptcha;
    window.onCaptchaError = this.onCaptchaError;
    //var currentUrl = "https://subsys.hispecservices.com/default/login/sso/b1a59b315fc9a3002ce38bbe070ec3f5";
    var currentUrl = window.location.href;
    let url = process.env.API_PATH + "/getDomainDetails";

    await axios
      .post(
        url,
        {
          st_subdomain: this.domain,
          st_whitelabel: this.whitelabel
        },
        {
          headers: { "Content-Type": "application/json" }
        }
      )
      .then(response => {
        this.currentVersion = response.data.versionDetails.st_release_no;
        if (response.data.flag === 1) {
          this.subscriberid = response.data.data.in_subscription_id;
          this.setDomainDesign(response.data.data);
          if (this.subscriptionId && this.adminToken) {
            this.handleSSO(currentUrl, this.subscriptionId, this.adminToken);
          } else if(currentUrl.includes("sso")) {
            this.handleSSO(currentUrl);
          }
        } else if (response.data.flag === 4) {
          this.$awn.alert("The page you requested does not exists.");
          var loc = location.host;
          var locArr = loc.split(".");
          loc = location.protocol + "//" + locArr[1] + "." + locArr[2];
          window.location.href = loc;
        } else {
          this.$awn.alert("The page you requested does not exists.");
          window.location.href = redirectUrl;
          // this.$router.push({
          //   name: "ErrorPage"
          // });
        }
      })
      .catch();
    
      // Initialize reCAPTCHA when ready
      this.$nextTick(() => {
        if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
          this.initializeRecaptcha();
        } else {
          // Set global callback for reCAPTCHA API onload
          const self = this;
          window.onRecaptchaApiReady = function() {
            self.$nextTick(() => {
              self.initializeRecaptcha();
            });
          };
          
          // Polling fallback: check every 500ms for up to 15 seconds
          // Covers cases where onload already fired or callback was missed
          let attempts = 0;
          const maxAttempts = 30;
          const recaptchaPollInterval = setInterval(() => {
            attempts++;
            if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
              clearInterval(recaptchaPollInterval);
              if (this.recaptchaWidgetId === null) {
                this.initializeRecaptcha();
              }
            } else if (attempts >= maxAttempts) {
              clearInterval(recaptchaPollInterval);
              console.error('reCAPTCHA failed to load after 15 seconds.');
            }
          }, 500);
        }
      });
  },
  methods: {
    async handleSSO(currentUrl, routeSubscriptionId = null, routeAdminToken = null) {
      let subscriptionIdFromUrl = routeSubscriptionId;
      let adminLoginTokenFromUrl = routeAdminToken;
     
      if (subscriptionIdFromUrl && adminLoginTokenFromUrl) {
  
      } else {
        // Otherwise parse from URL
        try {
          // Check if this is in the pathname (direct link)
          const urlPath = currentUrl.split('?')[0]; // Remove query string
          const pathParts = urlPath.split('/').filter(part => part.length > 0); // Remove empty parts
          const ssoIndex = pathParts.indexOf('sso');
          
          if (ssoIndex !== -1 && pathParts.length > ssoIndex + 2) {
            subscriptionIdFromUrl = pathParts[ssoIndex + 1];
            adminLoginTokenFromUrl = pathParts[ssoIndex + 2];
          }
          
          // If not found in pathname, check redirect_url query parameter
          if (!adminLoginTokenFromUrl) {
            const urlObj = new URL(currentUrl);
            const redirectUrl = urlObj.searchParams.get('redirect_url');
            
            if (redirectUrl) {
              // Decode the redirect URL
              const decodedRedirectUrl = decodeURIComponent(redirectUrl);
              const redirectParts = decodedRedirectUrl.split('/').filter(part => part.length > 0);
              const redirectSsoIndex = redirectParts.indexOf('sso');
              
              if (redirectSsoIndex !== -1 && redirectParts.length > redirectSsoIndex + 2) {
                subscriptionIdFromUrl = redirectParts[redirectSsoIndex + 1];
                adminLoginTokenFromUrl = redirectParts[redirectSsoIndex + 2];
              }
            }
          }
        } catch (error) {
          console.error('Error parsing URL:', error);
        }
      }
      
      if (subscriptionIdFromUrl && adminLoginTokenFromUrl) {
        this.adminLoginToken = adminLoginTokenFromUrl;
        
        this.ssoStatus = true;
        
        let url = process.env.API_PATH + "/getSubscriberDetailsSSO";

        try {
          const response = await axios.post(
            url,
            {
              subscriptionId: this.subscriberid,
              adminLoginToken: this.adminLoginToken,
              ssoSubscriptionId: subscriptionIdFromUrl
            },
            {
              headers: { "Content-Type": "application/json" }
            }
          );
          
          if (response.data && response.data.flag === 1 && response.data.data && response.data.data[0]) {
            this.email = response.data.data[0].st_user_name;
            this.password = response.data.data[0].st_normal_password;
            this.account = response.data.data.domain;
            this.isSso = true;
            await this.login();
          } else {
            console.warn('Invalid SSO response:', response.data);
            this.ssoStatus = false;
            this.isSso = false;
            this.error = response.data && response.data.msg ? response.data.msg : 'SSO link has expired. Please log in manually.';
            this.$awn.warning(this.error);
          }
        } catch (error) {
          console.error('SSO token validation error:', error);
          this.ssoStatus = false;
          this.isSso = false;
          this.error = 'SSO link has expired or is invalid. Please log in manually.';
          this.$awn.warning(this.error);
        }
      } else {
        console.warn('Invalid SSO URL format - missing parameters');
        this.ssoStatus = false;
        this.isSso = false;
        this.error = 'Invalid SSO link format. Please log in manually.';
      }
    },
    setDomainDesign(designdata) {
      this.siteTitle = ((designdata.st_default_site_name) ? (this.domain == 'www' ? '' : ' - ' + this.domain) + ((this.whitelabel && this.whitelabel != 'default') ? (': ' + this.whitelabel + ' - ' + designdata.st_site_name) : '') + ' - ' + designdata.st_default_site_name : '');
      this.siteDefaultTitle = designdata.st_default_site_name;
      // Updating favicon according to whitelabel details
      if (designdata.favicon_image_url && designdata.favicon_image_url.length > 0) {
        const favicon = document.getElementById("favicon");
        favicon.href = designdata.favicon_image_url;
      }
      if (this.whitelabel === "") {

        this.$router.push({
          name: "LabelLogin",
          params: {
            domain: this.domain,
            whitelabel: designdata.st_subdomain_name
          }
        });
      } else if (designdata.st_subdomain_name != this.whitelabel) {
        this.$router.push({
          name: "LabelLogin",
          params: {
            domain: this.domain,
            whitelabel: designdata.st_subdomain_name
          }
        });
        // router.replace({ name: 'Login', params: { domain, whitelabel } })
      }
      this.account =
        this.domain.length > 0 && this.domain != "www" ? this.domain : "";
      this.isActive3 = 1;
      const customStyle = document.querySelector("body");
      customStyle.style.setProperty(
        "--headerColor",
        "#" + designdata.st_header_color
      );
      customStyle.style.setProperty(
        "--headerTextColor",
        "#" + designdata.st_header_text_color
      );
      customStyle.style.setProperty(
        "--buttonLinkColor",
        "#" + designdata.st_button_link_color
      );
      customStyle.style.setProperty(
        "--buttonTextColor",
        "#" + designdata.st_button_text_color
      );
      this.dialogsData = designdata;
      // Updating logo according to whitelabel details
      if (designdata.st_logo_image && designdata.st_logo_image.length > 0) {
        this.logoImage =
          frontHostName +
          process.env.CAKE_BASE_PATH +
          "img/whitelabel/" +
          designdata.st_logo_image;
      }
    },
    onAdded(file, index) {
      supportFormData.append("supportFileAttachment[]", file);
    },
    showSupport(){
        this.resetSupportData();
        this.$refs.supportModal.show();
    },
    resetSupportData(){
        this.txtUserSupportEmail = "";
        this.txtSupportMessage = "";
        this.$refs.txtSupportFile.removeAllFiles();
        this.errors.clear();
        this.$nextTick(() => {
            this.errors.clear();
            this.$nextTick(() => {
                this.$validator.reset();
            });
        });
    },
    async sendSupport() {
        this.$validator.validateAll().then(async result => {
        if (result) {
          let url = process.env.API_PATH + "/sendSupportMail";
          let files = this.$refs.txtSupportFile.dropzone.files;
          let formData = new FormData();

          // if you want to upload multiple files at once loop
          // through the array of files
          for (let i = 0; i < files.length; i++) {
            formData.append("supportFileAttachment[]", files[i]);
          }
          formData.append("txtUserSupportEmail", this.txtUserSupportEmail);
          formData.append("txtSupportMessage", this.txtSupportMessage);
          await axios
            .post(url, formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(response => {
              if (response.data.data.FLAG === 1) {
                  this.$awn.success(response.data.data.MSG);
                    this.$refs.supportModal.hide();
              }else{
                  this.$awn.success('Something might wrong. Try later');
              }
            })
            .catch();
        }
      });
    },
    addClass1() {
      if (this.email !== "") {
        this.isActive1 = 1;
      } else {
        this.isActive1 = 0;
      }
    },
    addClass2() {
      if (this.password !== " ") {
        this.isActive2 = 1;
      } else {
        this.isActive2 = 0;
      }
    },
    addClass3() {
      if (this.account !== "") {
        this.isActive3 = 1;
      } else {
        this.isActive3 = 0;
      }
    },
    async login() {
      this.$wait.start("logging in");
      this.errorSupport = false;
      
      // Get reCAPTCHA token from Google - Skip for SSO auto-login
      let recaptchaToken = '';
      
      if (!this.isSso) {
        // Only require reCAPTCHA for manual login, not SSO
        if (typeof grecaptcha !== 'undefined' && this.recaptchaWidgetId !== null) {
          recaptchaToken = grecaptcha.getResponse(this.recaptchaWidgetId);
        }
        
        if (!recaptchaToken) {
          this.$wait.end("logging in");
          this.$awn.warning('Please complete the reCAPTCHA verification.');
          return;
        }
      }
      
      let url = process.env.API_PATH + "/newLogin";
      let formData = {
        txtEmail: this.email,
        txtPassword: this.password,
        txtAccount: this.account,
        txtWhiteLabel: this.whitelabel,
        requestType: "online",
        isSso:this.isSso,
        isCheck:"check",
        recaptchaToken: recaptchaToken,
        checkRecaptcha: !this.isSso ? "check" : "uncheck"
      };
      let requestData = JSON.stringify(formData);
      const key = CryptoJS.enc.Hex.parse(encrypted_key);
      const ivs = CryptoJS.lib.WordArray.random(16);
      var encrypted = CryptoJS.AES.encrypt(requestData, key, {
          iv: ivs,
          padding: CryptoJS.pad.ZeroPadding,
      });
      var response_data = encrypted.toString();
      await axios
        .post(
          url,
          {
            request_data: response_data,
            v: encrypted.iv.toString(),
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(request => this.handleLoginResponse(request))
        .catch(() => this.loginFailed());
    },
    // Handle login response - check if OTP is needed
    handleLoginResponse(req) {
      const keys = CryptoJS.enc.Hex.parse(encrypted_key);
      var encryptedResponse = req.data.response_data;
      var resIv = CryptoJS.enc.Hex.parse(req.data.v);
      var decrypted = CryptoJS.AES.decrypt(encryptedResponse, keys, {
        iv : resIv,
        padding: CryptoJS.pad.ZeroPadding,
      });
      var response_datas = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
      req.data = response_datas;
      
      if (!req.data.flag) {
        this.loginFailed(req);
        return;
      }
      
      // For SSO logins, skip OTP and complete login directly
      if (this.isSso) {
        this.completeLogin(req);
        return;
      }
      
      // If is_mfa is 0, skip OTP verification and complete login normally
      if (req.data.data.is_mfa === 0 || req.data.data.is_mfa === false) {
        this.tempLoginData = req;
        this.$wait.end("logging in");
        this.completeLogin(req);
        return;
      }
      
      // Check if user has a valid "Remember me" token
      const rememberMeToken = this.getRememberMeToken(req.data.data.in_user_id);
      if (rememberMeToken) {
        // Skip OTP and complete login
        this.tempLoginData = req;
        this.$wait.end("logging in");
        this.completeLogin(req);
        return;
      }
      
      // For non-SSO logins without remember me token, store login data and trigger OTP flow
      this.tempLoginData = req;
      this.$wait.end("logging in");
      this.showOtpStep = true;
      this.sendOtp();
    },
    
    // Send OTP to user's email
    async sendOtp() {
      let url = process.env.API_PATH + "/sendLoginOtp";
      this.sendingOtp = true;
      this.otpError = '';
      try {
        const response = await axios.post(
          url,
          {
            subscriptionId: this.tempLoginData.data.data.in_subscription_id,
            userId: this.tempLoginData.data.data.in_user_id
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        );
        
        if (response.data.flag === 1) {
          this.startOtpTimer();
          this.$awn.success('OTP sent to your email address.');
        } else {
          this.$awn.alert(response.data.msg || 'Failed to send OTP. Please try again.');
          this.goBackToLogin();
        }
      } catch (error) {
        console.error('Error sending OTP:', error);
        this.$awn.alert('Failed to send OTP. Please try again.');
        this.goBackToLogin();
      } finally {
        this.sendingOtp = false;
      }
    },
    
    // Verify the entered OTP
    async verifyOtp() {
      if (this.otpCode.length !== 6) {
        this.otpError = 'Please enter a valid 6-digit OTP.';
        return;
      }
      
      this.otpVerifying = true;
      this.otpError = '';
      
      let url = process.env.API_PATH + "/verifyLoginOtp";
      try {
        const response = await axios.post(
          url,
          {
            otp: this.otpCode,
            userId: this.tempLoginData.data.data.in_user_id
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        );
        
        if (response.data.flag === 1) {
          this.clearOtpTimer();
          
          // If "Remember me" is checked, store token for 30 days
          if (this.rememberMe) {
            this.setRememberMeToken(this.tempLoginData.data.data.in_user_id);
          }
          
          this.$wait.start("logging in");
          this.completeLogin(this.tempLoginData);
        } else {
          this.otpError = response.data.msg || 'Invalid OTP. Please try again.';
        }
      } catch (error) {
        console.error('Error verifying OTP:', error);
        this.otpError = 'Failed to verify OTP. Please try again.';
      } finally {
        this.otpVerifying = false;
      }
    },
    
    // Resend OTP
    async resendOtp() {
      this.otpCode = '';
      this.otpError = '';
      this.canResendOtp = false;
      await this.sendOtp();
    },
    
    // Start OTP countdown timer
    startOtpTimer() {
      this.otpTimer = 60;
      this.canResendOtp = false;
      this.clearOtpTimer();
      
      this.otpTimerInterval = setInterval(() => {
        this.otpTimer--;
        if (this.otpTimer <= 0) {
          this.canResendOtp = true;
          this.clearOtpTimer();
        }
      }, 1000);
    },
    
    // Clear OTP timer
    clearOtpTimer() {
      if (this.otpTimerInterval) {
        clearInterval(this.otpTimerInterval);
        this.otpTimerInterval = null;
      }
    },
    
    // Cancel OTP verification / Go back to login
    goBackToLogin() {
      this.clearOtpTimer();
      this.otpCode = '';
      this.otpError = '';
      this.showOtpStep = false;
      this.rememberMe = false;
      this.error = '';
      this.tempLoginData = null;
      
      // Re-initialize reCAPTCHA when returning to login
      this.$nextTick(() => {
        if (this.$refs.recaptchaContainer) {
          this.$refs.recaptchaContainer.innerHTML = '';
          this.recaptchaWidgetId = null;
          if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
            this.initializeRecaptcha();
          }
        }
      });
      
      this.$awn.info('Returning to login.');
    },
    
    // Cancel OTP verification (alias for backward compatibility)
    cancelOtp() {
      this.goBackToLogin();
    },
    
    // Only allow numbers in OTP input
    onlyNumbers(event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    
    // Complete login after OTP verification (original loginSuccessful logic)
    completeLogin(req) {
      // localStorage.setItem("user", JSON.stringify(req.data.data));
      this.$session.start();
      // this.$session.set("userDetails", req.data.data);
      this.$session.set("requestId", req.data.data.in_user_id);
      this.$session.set("jwt_token", req.data.token);
      this.$session.set("propertyname", req.data.data.st_user_name);
      this.$session.set("whitelabel", req.data.data.whitelabel);
      this.$session.set("user_permissions", req.data.user_permissions);
      this.$session.set("requestUserType", req.data.data.in_user_type);
      this.$session.set("subscriptionId", req.data.data.in_subscription_id);
      // this.$session.set("isAllowPhotoUpload", req.data.data.is_allow_photo_upload);
      this.$cookies.set(
        req.data.cakeData.cakeCookieName,
        req.data.cakeData.cakeSessionId,
        "0",
        req.data.cakeData.cakeCookiePath
      );
      this.$session.set("lang", req.data.lang);
      this.$i18n.locale = this.$session.get("lang");
      this.$validator.localize(this.$session.get("lang"));

      // Set awesome notification labels in respective language
      this.$awn.options.labels.tip = this.$t("notificationLabels.tip");
      this.$awn.options.labels.info = this.$t("notificationLabels.info");
      this.$awn.options.labels.success = this.$t("notificationLabels.success");
      this.$awn.options.labels.warning = this.$t("notificationLabels.warning");
      this.$awn.options.labels.alert = this.$t("notificationLabels.alert");
      this.$awn.options.labels.async = this.$t("notificationLabels.async");
      this.$awn.options.labels.confirm = this.$t("notificationLabels.confirm");

      axios.defaults.headers.common["Authorization"] = this.$session.get(
        "jwt_token"
      );

      localStorage.token = req.data.flag;
      this.error = false;
      // window.location = 'http://192.168.1.100/hispec_report/code/dashboard/'
      let wlabel =
        this.whitelabel.length > 0 && this.whitelabel !== defaultWhiteLabel
          ? this.whitelabel
          : req.data.data.whitelabel;

      let redirection = '';
      if(this.$route.query.redirect_url == null)
      {
        redirection = (req.data.data.in_user_type == 1) ? process.env.CAKE_ADMIN_PATH : process.env.CAKE_PATH;
      }
      else
      {
        redirection = this.$route.query.redirect_url;
      }
      var loc =
        frontHostName +
        process.env.CAKE_BASE_PATH +
        wlabel +
        redirection;
      window.location.href = loc;
      // this.$router.replace(this.$route.query.redirect || '/dashboard')
    },
    loginFailed(req) {
      this.$wait.end("logging in");

      if (req.data.msg == "accountInactive") {
        this.error = "Your account has been locked! Please contact your administrator.";
      } else {
      this.error = req.data.msg;
      }
      delete localStorage.token;
      
      // Force reCAPTCHA widget to be destroyed and re-rendered after failed login
      if (!this.isSso && typeof grecaptcha !== 'undefined') {
        if (this.$refs.recaptchaContainer) {
          this.$refs.recaptchaContainer.style.display = '';
          // Remove the widget from DOM
          this.$refs.recaptchaContainer.innerHTML = '';
        }
        this.recaptchaWidgetId = null;
        this.recaptchaLoginToken = '';
        this.recaptchaLoginExpired = false;
        this.$nextTick(() => {
          this.initializeRecaptcha();
        });
      }
    },
    imageUrlAlt(event) {
      event.target.src = require("../assets/images/logo.png");
    },
    previewTemplate() {
      return `<li>
                <i class="fa fa-file-o"></i>
                <span><a class="dzjs-filename" data-dz-name></a></span>
                <a href="javascript:void(0);" class="scanning-spinner pull-right" style="display: none;"><i class="fa fa-spinner fa-spin"></i></a>
                <a href="javascript:void(0);" class="scanning-success pull-right" style="color: green; display: none;" data-toggle="tooltip" title="The file does not contain a virus."><i class="fa fa-check"></i></a>
                <a href="javascript:void(0);" class="scanning-error pull-right" style="color: red; display: none; width: 34px;" data-toggle="tooltip" title="The file contains a virus."><i class="fa fa-times"></i></a>
                <a href="javascript:void(0);" class="pull-right" style="cursor: pointer" title="Delete Attachment" data-dz-remove>
                    <i class="fa fa-trash" style="cursor: pointer"></i>
                </a>
                <div class="hidden dropzone-error-message" style="margin: 0 35px;">
                    <a href="#" class="text-danger" title="" data-dz-errormessage></a>
                </div>
            </li>`;
    },
    async verifyAccount(){
      this.verificationLink = false;
      this.error = false;
      
      let url = process.env.API_PATH + "/verifyAccount";
      await axios
        .post(
          url,
          {
            txtAccount: this.account,
            requestType: "online"
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(response => {
           if(response.data.flag == 3){
             this.verificationLink = true;
             return;
           }
           if (!response.data.flag) {
              this.loginFailed(response);
              return;
           }
             this.error = false;
             var locArr = location.host.split(".");
             var topDomain = locArr[locArr.length - 1]; // Get last element from array like com, cloud, net
             var loc = location.protocol+'//'+this.account+'.'+process.env.REDIRECT_DOMAIN+'.'+topDomain;
             window.location.href = loc;
        })
        .catch((err) => {
             this.loginFailed() 
        });
    },
    gotoforgotpswd(){
      window.location.href="/forgot-pswd";
    },
    async resendVerificationEmail(){
      let url = process.env.API_PATH + "/resendVerificationEmailToAccountAdmin";
      await axios
        .post(
          url,
          {
            txtAccount: this.account,
            requestType: "online"
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(response => { 
            if (!response.data.flag) {
               this.loginFailed(response);
               return;
            }
            this.$awn.success(response.data.msg);
            this.verificationLink = false;
         }).catch((err) => { this.loginFailed() });
    },
    onVerifyCaptcha(token) {
      this.recaptchaToken = token;
      this.recaptchaExpired = false;
    },
    onExpireCaptcha() {
      this.recaptchaToken = '';
      this.recaptchaExpired = true;
    },
    onVerifyLoginCaptcha(token) {
      this.recaptchaLoginToken = token;
      this.recaptchaLoginExpired = false;
    },
    onExpireLoginCaptcha() {
      this.recaptchaLoginToken = '';
      this.recaptchaLoginExpired = true;
    },
    onCaptchaError(error) {
      console.error('reCAPTCHA error:', error);
      this.$awn.alert('reCAPTCHA error. Please try again.');
    },
    initializeRecaptcha() {
      try {
        if (!this.$refs.recaptchaContainer) {
          console.warn('reCAPTCHA container ref not available yet, retrying...');
          this.$nextTick(() => {
            if (this.$refs.recaptchaContainer && typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
              this.initializeRecaptcha();
            }
          });
          return;
        }
        if (typeof grecaptcha === 'undefined' || typeof grecaptcha.render !== 'function') {
          console.warn('grecaptcha not ready yet.');
          return;
        }
        // Prevent double-rendering
        if (this.recaptchaWidgetId !== null) {
          return;
        }
        this.recaptchaWidgetId = grecaptcha.render(this.$refs.recaptchaContainer, {
          'sitekey': recaptchaSiteKey,
          'callback': (token) => {
            this.recaptchaLoginToken = token;
            this.recaptchaLoginExpired = false;
          },
          'expired-callback': () => {
            this.recaptchaLoginToken = '';
            this.recaptchaLoginExpired = true;
            this.$awn.warning('reCAPTCHA expired. Please verify again.');
          },
          'error-callback': (error) => {
            this.$awn.alert('reCAPTCHA error. Please try again.');
          }
        });
      } catch (error) {
        console.error('Failed to initialize reCAPTCHA:', error);
        // If render fails (e.g., container already has a widget), reset and retry once
        if (error.message && error.message.includes('already been rendered')) {
          this.recaptchaWidgetId = null;
        }
      }
    },
    
    // Set Remember Me token for 30 days
    setRememberMeToken(userId) {
      const token = CryptoJS.lib.WordArray.random(32).toString();
      const expiryTime = Date.now() + (30 * 24 * 60 * 60 * 1000); // 30 days from now
      
      const rememberMeData = {
        userId: userId,
        token: token,
        expiry: expiryTime
      };
      
      localStorage.setItem('rememberMeToken', JSON.stringify(rememberMeData));
    },
    
    // Get Remember Me token if valid
    getRememberMeToken(userId) {
      try {
        const rememberMeData = localStorage.getItem('rememberMeToken');
        if (!rememberMeData) {
          return null;
        }
        
        const data = JSON.parse(rememberMeData);
        
        // Check if token exists, belongs to this user, and hasn't expired
        if (data.userId === userId && data.expiry > Date.now()) {
          return data.token;
        } else {
          // Token expired or belongs to different user, remove it
          localStorage.removeItem('rememberMeToken');
          return null;
        }
      } catch (error) {
        console.error('Error reading remember me token:', error);
        localStorage.removeItem('rememberMeToken');
        return null;
      }
    },
    
    // Clear Remember Me token
    clearRememberMeToken() {
      localStorage.removeItem('rememberMeToken');
    }
  }
};
</script>
<style scoped>
/* OTP Inline Container */
.otp-inline-container {
    animation: slideInUp 0.4s ease-out;
}

.otp-inline-header {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
}

.otp-inline-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin: 0 0 8px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.otp-inline-title i {
    color: var(--buttonLinkColor);
    font-size: 28px;
}

.otp-inline-subtitle {
    font-size: 14px;
    color: #666;
    margin: 0;
}

.otp-inline-body {
    margin-bottom: 30px;
}

.otp-inline-footer {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
}

.otp-btn-back {
    background: #f0f0f0;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 12px 20px;
    font-size: 14px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 110px;
}

.otp-btn-back:hover:not(:disabled) {
    background: #e0e0e0;
    color: #333;
    transform: translateY(-2px);
}

.otp-btn-back:active:not(:disabled) {
    transform: translateY(0);
}

.otp-btn-back:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* OTP Modal Wrapper */
.otp-modal-wrapper >>> .modal-content {
    border-radius: 16px;
    border: none;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.otp-modal-wrapper >>> .modal-header {
    display: none;
}

/* OTP Modal Content */
.otp-modal-content {
    padding: 0;
    border-radius: 16px;
    background: #fff;
    overflow: hidden;
}

/* OTP Header */
.otp-header {
    color: #8040b8;
    padding: 20px 15px 15px;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.otp-title {
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 5px 0;
    letter-spacing: -0.5px;
}

.otp-subtitle {
    font-size: 14px;
    opacity: 0.95;
    margin: 0;
    font-weight: 400;
}

/* OTP Body */
.otp-body {
    padding: 25px 30px 20px;
}

.otp-input-wrapper {
    position: relative;
    margin-bottom: 30px;
}

.otp-input-field {
    width: 100%;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 20px;
    text-align: center;
    padding: 10px 15px;
    border: none;
    background: #f8f9fa;
    border-radius: 12px;
    transition: all 0.3s ease;
    color: var(--buttonLinkColor);
    font-family: 'Courier New', monospace;
}

.otp-input-field:focus {
    outline: none;
    background: #f0f5ff;
    box-shadow: 0 0 0 4px rgba(var(--buttonLinkColor), 0.1),
                0 8px 16px rgba(0, 0, 0, 0.08);
}

.otp-input-field::placeholder {
    color: #d0d0d0;
    letter-spacing: 20px;
}

.otp-input-underline {
    height: 3px;
    background: linear-gradient(90deg, var(--buttonLinkColor), #0056b3);
    border-radius: 2px;
    margin-top: 8px;
    transform: scaleX(0);
    transition: transform 0.3s ease;
    transform-origin: left;
}

.otp-input-field:focus ~ .otp-input-underline {
    transform: scaleX(1);
}

/* Error Message */
.otp-error-message {
    background: #fff3cd;
    border-left: 4px solid #ffc107;
    color: #856404;
    padding: 12px 15px;
    border-radius: 8px;
    font-size: 13px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    animation: slideIn 0.3s ease-out;
}

.otp-error-message i {
    font-size: 16px;
}

/* Timer Section */
.otp-timer-section {
    text-align: center;
    margin-bottom: 30px;
}

.otp-timer {
    color: #666;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.otp-timer strong {
    color: var(--buttonLinkColor);
    font-weight: 700;
    font-size: 16px;
}

.otp-resend-link {
    color: var(--buttonLinkColor);
    text-decoration: none;
    font-weight: 600;
    font-size: 15px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.3s ease;
    background: rgba(var(--buttonLinkColor), 0.05);
    cursor: pointer;
}

.otp-resend-link:hover {
    background: rgba(var(--buttonLinkColor), 0.1);
    transform: translateY(-2px);
}

.otp-resend-link i {
    transition: transform 0.3s ease;
}

.otp-resend-link:hover i {
    transform: rotate(180deg);
}

/* OTP Footer */
.otp-footer {
    display: flex;
    gap: 12px;
    padding: 15px 30px;
    border-top: 1px solid #f0f0f0;
    justify-content: flex-end;
}

.otp-btn {
    padding: 12px 24px;
    font-size: 15px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-width: 120px;
}

.otp-btn i {
    font-size: 14px;
}

.otp-btn-cancel {
    background: #f0f0f0;
    color: #666;
}

.otp-btn-cancel:hover:not(:disabled) {
    background: #e0e0e0;
    color: #333;
}

.otp-btn-verify {
    background: var(--buttonLinkColor);
    color: white;
    min-width: 140px;
    box-shadow: 0 4px 12px rgba(var(--buttonLinkColor), 0.3);
}

.otp-btn-verify:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(var(--buttonLinkColor), 0.4);
}

.otp-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none !important;
}

.otp-btn-verify:disabled {
    background: linear-gradient(135deg, #ccc 0%, #999 100%);
}

/* Footer Info */
.otp-footer-info {
    background: #f8f9fa;
    border-top: 1px solid #f0f0f0;
    padding: 10px 30px;
    font-size: 12px;
    color: #666;
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.otp-footer-info i {
    color: #999;
    margin-top: 1px;
    flex-shrink: 0;
}

.otp-footer-info small {
    line-height: 1.6;
}

/* Animations */
@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(-10px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
    transform: translateX(-10px);
}

/* Loading spinner animation */
@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.fa-spin {
    animation: spin 1s linear infinite;
}

/* Responsive adjustments */
@media (max-width: 480px) {
    .otp-header {
        padding: 10px;
    }

    .otp-title {
        font-size: 24px;
    }

    .otp-body {
        padding: 30px 20px 20px;
    }

    .otp-input-field {
        font-size: 40px;
        letter-spacing: 16px;
        padding: 16px 10px;
    }

    .otp-footer {
        flex-direction: column;
        gap: 10px;
        padding: 15px 20px;
    }

    .otp-btn {
        width: 100%;
        min-width: auto;
    }

    .otp-footer-info {
        padding: 10px 20px;
    }
}

/* Remember Me Checkbox Styles */
.remember-me-checkbox {
    margin-bottom: 10px;
}

.custom-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    font-size: 14px;
    color: #666;
}

.checkbox-input {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    cursor: pointer;
    accent-color: var(--buttonLinkColor);
    transition: all 0.3s ease;
}

.checkbox-input:hover {
    opacity: 0.8;
}

.checkbox-label {
    cursor: pointer;
    transition: color 0.3s ease;
}

.checkbox-input:checked + .checkbox-label {
    color: var(--buttonLinkColor);
    font-weight: 500;
}

/* OTP Sending Loader */
.otp-sending-loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease-in;
}

.loader-overlay {
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.loader-content {
    background: white;
    border-radius: 16px;
    padding: 40px;
    text-align: center;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    animation: slideUp 0.3s ease-out;
}

.spinner {
    width: 60px;
    height: 60px;
    margin: 0 auto 20px;
}

.spinner-circle {
    width: 100%;
    height: 100%;
    border: 4px solid #f0f0f0;
    border-top: 4px solid var(--buttonLinkColor);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.loader-text {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    margin: 0;
    letter-spacing: 0.5px;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginNew.vue